import React, { useEffect, useState } from "react";

// import { useSelector } from "react-redux";

import { Avatar, Select, Spin, Tooltip } from "antd";
import dayjs from "dayjs";

import CommonFooter from "../../../../../../core/common/footer/commonFooter";
import Table from "../../../../../../core/pagination/datatable";
// import { Edit, Eye } from "feather-icons-react/build/IconComponents";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { BASE_CRM_URL } from "../../../../../components/config/config";
import Swal from "sweetalert2";
import NewProject from "../../../Projects/NewProject";
import UpdateProject from "../../../Projects/UpdateProject";
// import { Link } from "react-router-dom";
// import { Edit, Eye, Trash2 } from "feather-icons-react/build/IconComponents";

const ProjectsTab = () => {
  const renderTooltip = (text) => {
    if (!text) return "N/A";

    return text.length > 45 ? (
      <Tooltip title={text}>
        <span>{text.substring(0, 45)}...</span>
      </Tooltip>
    ) : (
      text
    );
  };

  const [projectStatusOptions, setProjectStatusOptions] = useState([]);

  const getProjectStatuses = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}project/GetProjectStatus`);

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.Status,
        }));

        setProjectStatusOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const projectStatusCards = [
    {
      key: "New",
      label: "New",
      status: 1,
      icon: "fa-regular fa-circle-pause",
      iconClass: "bg-secondary bg-opacity-10 text-secondary",
    },
    {
      key: "InProgress",
      label: "In Progress",
      status: 2,
      icon: "fa-solid fa-spinner",
      iconClass: "bg-info bg-opacity-10 text-primary",
    },
    {
      key: "OnHold",
      label: "On Hold",
      status: 3,
      icon: "fa-solid fa-circle-pause",
      iconClass: "bg-warning bg-opacity-10 text-warning",
    },
    {
      key: "Finished",
      label: "Finished",
      status: 4,
      icon: "fa-solid fa-circle-check",
      iconClass: "bg-success bg-opacity-10 text-success",
    },
    {
      key: "Cancelled",
      label: "Cancelled",
      status: 5,
      icon: "fa-solid fa-circle-xmark",
      iconClass: "bg-danger bg-opacity-10 text-danger",
    },
  ];

  const columns = [
    {
      title: "Project Name",
      dataIndex: "name",
      sorter: (a, b) =>
        (a.projectName || "").localeCompare(b.projectName || ""),

      render: (text) => <span className="">{renderTooltip(text)}</span>,
    },

    {
      title: "Start Date",
      dataIndex: "start_date",
      width: 170,
      render: (date) => (
        <div>
          <i className="fa-solid fa-calendar-days text-primary me-2"></i>
          {date ? dayjs(date).format("DD-MM-YYYY") : "-"}
        </div>
      ),
    },

    {
      title: "Deadline",
      dataIndex: "deadline",
      render: (date) => {
        if (!date) return "-";

        const formattedDate = dayjs(date).format("DD-MM-YYYY");
        const due = dayjs(date);
        const days = due.startOf("day").diff(dayjs().startOf("day"), "day");

        return (
          <>
            <div>
              <i className="fa-solid fa-hourglass-half me-2 text-danger"></i>
              {formattedDate}
            </div>

            <small
              className={
                days < 0
                  ? "text-danger"
                  : days <= 7
                    ? "text-warning"
                    : "text-success"
              }
            >
              {/* <i className="fa-regular fa-clock me-1"></i>

              {days < 0
                ? `${Math.abs(days)} Days Overdue`
                : `${days} Days Left`} */}
            </small>
          </>
        );
      },
    },
    {
      title: "Members",
      dataIndex: "staff",
      width: 200,
      render: (_, record) => (
        <Avatar.Group
          max={{
            count: 3,
            style: {
              backgroundColor: "#f56a00",
              color: "#fff",
            },
          }}
        >
          {(record.staff || [])
            .filter((member) => member?.staff_name)
            .map((member, index) => {
              const name = member.staff_name;

              const initials = name
                .trim()
                .split(/\s+/)
                .map((x) => x[0])
                .join("")
                .toUpperCase();

              const avatarStyles = [
                { bg: "#E7F1FF", color: "#0D6EFD" },
                { bg: "#E8F8F0", color: "#198754" },
                { bg: "#FFF4E5", color: "#FD7E14" },
                { bg: "#F3E8FF", color: "#6F42C1" },
                { bg: "#E6FFFB", color: "#0DCAF0" },
                { bg: "#FCE7F3", color: "#D63384" },
              ];

              const style = avatarStyles[index % avatarStyles.length];

              return (
                <Tooltip key={member.staff_id} title={name} placement="top">
                  <Avatar
                    style={{
                      backgroundColor: style.bg,
                      color: style.color,
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                  >
                    {initials || "N/A"}
                  </Avatar>
                </Tooltip>
              );
            })}
        </Avatar.Group>
      ),
    },

    {
      title: "Status",
      dataIndex: "StatusName",

      render: (text, record) => {
        const getColor = (status) => {
          switch (status) {
            case "New":
              return "#6c757d";

            case "InProgress":
              return "#0d6efd";

            case "On Hold":
              return "#ffc107";

            case "Finished":
              return "#198754";

            case "Cancelled":
              return "#dc3545";

            default:
              return "#6c757d";
          }
        };

        return (
          <Select
            value={
              projectStatusOptions.find(
                (item) => item.label === (text || "New"),
              )?.value
            }
            style={{ width: 120 }}
            options={projectStatusOptions}
            onChange={(value) => {
              updateInvoiceStatus(record.id, value);
            }}
            dropdownStyle={{ zIndex: 9999 }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: 10,
                  }}
                ></i>

                {option.data.label}
              </div>
            )}
            labelRender={({ value }) => {
              const status = projectStatusOptions.find(
                (x) => x.value === value,
              );

              return (
                <span>
                  <i
                    className="fa-solid fa-circle me-2"
                    style={{
                      color: getColor(status?.label),
                      fontSize: 10,
                    }}
                  ></i>
                  {status?.label}
                </span>
              );
            }}
          />
        );
      },
    },

    {
      title: "Action",
      align: "center",
      render: (_, record) => (
        <>
          {/* <Link className="action-set" to="#" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v btn border"></i>
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link to="/crm/projectview" className="dropdown-item">
                <Eye className="me-2 text-info" />
                View
              </Link>
            </li>

            <li>
              <Link
                className="dropdown-item"
                onClick={(e) => {
                  e.preventDefault();
                  handleEditExpense(record);
                }}
              >
                <Edit className="me-2 text-secondary" />
                Edit
              </Link>
            </li>
          </ul> */}

          <div className="action-table-data">
            <div className="edit-delete-action ">
              <Link
                className="me-2 p-2  shadow-sm"
                onClick={(e) => {
                  e.preventDefault();
                  handleEditExpense(record);
                }}
              >
                <i className="ti ti-pencil text-primary"></i>
              </Link>
            </div>
          </div>
        </>
      ),
    },
  ];

  const { id } = useParams();

  const [customerData, setCustomerData] = useState({});

  const getCustomerDetails = async () => {
    try {
      // setCustomerLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}customers/GetCustomerDetails?CusId=${id}`,
      );

      if (response.data.Status) {
        setCustomerData(response.data.ResultData?.[0] || {});
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message || "Unable to fetch customer details.",
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (id) {
      getCustomerDetails();
    }
  }, [id]);

  console.log(customerData);

  const [projectDrawerOpen, setProjectDrawerOpen] = useState(false);

  const handleExpenseClose = () => {
    setProjectDrawerOpen(false);
  };

  const [selectedStatus, setSelectedStatus] = useState(0);
  const [loading, setLoading] = useState(false);
  console.log(loading);

  const [projects, setProjects] = useState([]);
  const [projectCounts, setProjectCounts] = useState({
    NotStarted: 0,
    InProgress: 0,
    Finished: 0,
    Cancelled: 0,
  });

  console.log(projectCounts);

  const fetchProjectCounts = async () => {
    try {
      const response = await axios.get(
        `${BASE_CRM_URL}project/GetProjectCountsByCus?clientId=${id}`,
      );

      if (response.data?.Status && Array.isArray(response.data.ResultData)) {
        const data = response.data.ResultData;

        const counts = {
          NotStarted: data.find((item) => item.Id === 1)?.TotalCount || 0,

          InProgress: data.find((item) => item.Id === 2)?.TotalCount || 0,

          Finished: data.find((item) => item.Id === 4)?.TotalCount || 0,

          Cancelled: data.find((item) => item.Id === 5)?.TotalCount || 0,
        };

        setProjectCounts(counts);
      }
    } catch (error) {
      console.error("Error fetching project counts:", error);
    }
  };

  const fetchProjects = async (status = 0) => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}project/GetCustomerProjects/${id}/${status}`,
      );

      if (response.data?.Status) {
        const data = response.data.ResultData || [];
        setProjects(data);

        fetchProjectCounts(id);
      } else {
        setProjects([]);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      setProjects([]);
    } finally {
      setLoading(false);
    }
  };
  const updateInvoiceStatus = async (ProjectId, statusId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}project/UpdateProjectStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: ProjectId,
            status: statusId,
          }),
        },
      );

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1200,
          showConfirmButton: false,
        });

        fetchProjects(0);
        fetchProjectCounts(id);
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.Message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchProjectCounts();
    fetchProjects(0);
    getProjectStatuses();
  }, []);

  const handleStatusClick = (status) => {
    setSelectedStatus(status);
    fetchProjects(status);
  };

  const [editExpenseOpen, setEditExpenseOpen] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);

  const handleEditExpense = (record) => {
    setSelectedExpense(record);
    setEditExpenseOpen(true);
  };

  const handleCloseEditExpense = () => {
    setEditExpenseOpen(false);
    setSelectedExpense(null);
  };

  return (
    <div>
      <div className="row g-3">
        {projectStatusCards.map((item) => (
          <div className="col-12 col-md-6 col-lg d-flex" key={item.key}>
            <div
              className={`card shadow-sm revenue-widget flex-fill border ${
                selectedStatus === item.status ? "border-primary" : ""
              }`}
              style={{ cursor: "pointer" }}
              onClick={() => handleStatusClick(item.status)}
            >
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">{projectCounts[item.key]}</h4>

                  <p className="mb-0 fw-semibold">{item.label}</p>
                </div>
                <div
                  className={`rounded-circle  ${item.iconClass} bg-opacity-10 d-flex align-items-center justify-content-center`}
                  style={{ width: 45, height: 45 }}
                >
                  <i className={`${item.icon} fs-4`}></i>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="card table-list-card ">
        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
          <div className="search-set"></div>
          <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-success btn-sm me-2"
                onClick={(e) => {
                  e.preventDefault();
                  setProjectDrawerOpen(true);
                }}
              >
                <i className="ti ti-circle-plus fs-4 "> </i>
              </Link>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className=" table-responsive">
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "250px", // adjust height if needed
                }}
              >
                <Spin size="large" />
              </div>
            ) : (
              <Table columns={columns} dataSource={projects} />
            )}
          </div>
        </div>
      </div>
      <NewProject
        open={projectDrawerOpen}
        onClose={handleExpenseClose}
        getProjects={fetchProjects}
        customerId={id}
        type="project"
        onProjectAdded={() => fetchProjects(id)}
      />

      <UpdateProject
        open={editExpenseOpen}
        onClose={handleCloseEditExpense}
        getProjects={fetchProjects}
        record={selectedExpense}
        customerId={id}
        type="project"
        onProjectAdded={() => fetchProjects(id)}
      />

      <CommonFooter />
    </div>
  );
};

export default ProjectsTab;
